import React from 'react';
import PropTypes from 'prop-types';

import CashbackPresenter from '../../../../../../../presenters/CashbackPresenter';

import CashbackCell from './components/CashbackCell';

const CashbacksTable = (props) => {
  const {
    fastCashId,
    cashbacks,
    onDeleteDialogOpen,
    onEditStateDialogOpen,
    onEditModalOpen,
  } = props;
  return (
    <table className="tables">
      <thead>
        <tr>
          <th>Date</th>
          <th>Store name</th>
          <th>Rate</th>
          <th>Amount</th>
          <th>Source</th>
          <th>State</th>
          <th>Transaction Amount</th>
          <th>Actions</th>
        </tr>
      </thead>
      {cashbacks.map((cashback) => (
        <CashbackCell
          fastCashId={fastCashId}
          key={CashbackPresenter.id(cashback)}
          cashback={cashback}
          onDeleteDialogOpen={() => onDeleteDialogOpen(cashback)}
          onEditModalOpen={onEditModalOpen}
          onEditStateDialogOpen={() => onEditStateDialogOpen(cashback)}
        />
      ))}
    </table>
  );
};

export default CashbacksTable;

CashbacksTable.propTypes = {
  cashbacks: PropTypes.arrayOf(CashbackPresenter.shape()).isRequired,
  onDeleteDialogOpen: PropTypes.func.isRequired,
  onEditStateDialogOpen: PropTypes.func.isRequired,
  onEditModalOpen: PropTypes.func.isRequired,
  fastCashId: PropTypes.string,
};

CashbacksTable.defaultProps = {
  fastCashId: null,
};
